import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function EmptyState({
  children,
  action,
  className,
}: {
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'corner-brand flex flex-col items-center gap-3 border border-dashed border-zinc-700 px-6 py-10 text-center',
        className
      )}
    >
      <p className="text-sm text-zinc-500">{children}</p>
      {action}
    </div>
  );
}
